// TODO-KPI-91 — AGIRLIKLI_ORT sıra ile eşleme: kayıt/içe aktarma anında alt kalem sayısı doğrulaması
// ve eşleme önizlemesi için saf yardımcılar (FE editör + BE kayıt yolları aynı kuralı paylaşır).
// Motor (kpi-formula.ts `wavg`) i. değer kalemini i. ağırlık kalemiyle eşler; sıra = set içi kalem
// sırası (`compareKpiSiblings`: orderIndex, sonra etiket). Sayılar eşit değilse hücre HESAPLANAMADI.
import { type FormulaAst, type FormulaNode } from "./kpi-formula.js";

export interface WeightedAvgRef {
  code: string;
  weightCode: string;
}

export interface WeightedAvgArityIssue extends WeightedAvgRef {
  valueCount: number;
  weightCount: number;
}

/** Kardeş sırası — motor (resolve-core) ve Excel (orderIndicators) ile aynı karşılaştırıcı. */
export function compareKpiSiblings(
  a: { orderIndex: number; label: string },
  b: { orderIndex: number; label: string },
): number {
  return a.orderIndex - b.orderIndex || a.label.localeCompare(b.label, "tr");
}

/** İfadedeki AGIRLIKLI_ORT çağrıları (ilk görülme sırası, tekil). */
export function listWeightedAvgRefs(ast: FormulaAst): WeightedAvgRef[] {
  const out: WeightedAvgRef[] = [];
  const visit = (n: FormulaNode): void => {
    switch (n.kind) {
      case "wavg":
        if (!out.some((r) => r.code === n.code && r.weightCode === n.weightCode)) {
          out.push({ code: n.code, weightCode: n.weightCode });
        }
        return;
      case "bin":
        visit(n.left);
        visit(n.right);
        return;
      case "neg":
        visit(n.arg);
        return;
      default:
        return;
    }
  };
  visit(ast);
  return out;
}

/**
 * Alt kalem sayısı eşit olmayan AGIRLIKLI_ORT çağrıları. `childCountOf(code)` undefined dönerse
 * (bilinmeyen kod) çağrı atlanır — bilinmeyen kod hatası mevcut doğrulamaya aittir; asla fırlatmaz.
 */
export function validateWeightedAvgArity(
  ast: FormulaAst,
  childCountOf: (code: string) => number | undefined,
): WeightedAvgArityIssue[] {
  const issues: WeightedAvgArityIssue[] = [];
  for (const ref of listWeightedAvgRefs(ast)) {
    const valueCount = childCountOf(ref.code);
    const weightCount = childCountOf(ref.weightCode);
    if (valueCount === undefined || weightCount === undefined) continue;
    if (valueCount !== weightCount) issues.push({ ...ref, valueCount, weightCount });
  }
  return issues;
}

/** 422 / editör uyarısı metni — etiket yoksa kod yazılır. */
export function formatWeightedAvgArityMessage(
  issue: WeightedAvgArityIssue,
  labelOf: (code: string) => string | undefined = () => undefined,
): string {
  const v = labelOf(issue.code) ?? issue.code;
  const w = labelOf(issue.weightCode) ?? issue.weightCode;
  return `AGIRLIKLI_ORT: alt kalem sayıları eşit değil (${v} ${String(issue.valueCount)}, ${w} ${String(issue.weightCount)}) — kalemler aynı sırada ve sayıda olmalı`;
}
